import { render, staticRenderFns } from "./CouponEditor.vue?vue&type=template&id=0faf4478&scoped=true"
import script from "./CouponEditor.vue?vue&type=script&lang=js"
export * from "./CouponEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf4478",
  null
  
)

export default component.exports